import i18n from "../../i18n";
import router from "@/router";
import { homePath } from "@/utils/access";

const actions = {
  triggerError(context, error) {
    console.log(error);
    //trigger snackbar if login data is not correct
    if (error == "Error: Request failed with status code 401") {
      context.commit(
        "CREATE_SNACKBAR",
        i18n.t("snackbars.loginDataWrong")
      );
    } else if (error == "Error: Request failed with status code 402") {
      //trigger error when license limits are reached
      context.dispatch("triggerUniversalAlert", {
        text: i18n.t("snackbars.licenseLimitText"),
        heading: i18n.t("snackbars.licenseLimitHeading"),
        type: "warning",
      });
    } else if (error == "Error: Request failed with status code 409") {
      //trigger error when user already exists
      context.dispatch("triggerUniversalAlert", {
        text: i18n.t("snackbars.emailTakenText"),
        heading: i18n.t("snackbars.emailTakenHeading"),
        type: "warning",
      });
    } else if (
      error == "Error: Request failed with status code 403" ||
      error?.response?.status === 403
    ) {
      const message = error?.response?.data?.message;
      if (
        typeof message === "string" &&
        message.toLowerCase().includes("read-only")
      ) {
        return;
      }
      router.push(homePath()).catch(() => {});
      context.dispatch("triggerUniversalAlert", {
        text: i18n.t("snackbars.noPermissionText"),
        heading: i18n.t("snackbars.noPermissionHeading"),
        type: "warning",
      });
    } else {
      //otherwise cath all other errors
      context.commit(
        "CREATE_ERROR",
        i18n.t("snackbars.genericError")
      );
    }
  },
  triggerSnackbar(context, text) {
    context.commit("CREATE_SNACKBAR", text);
  },
  triggerErrorSnackbar(context, text) {
    context.commit("CREATE_ERROR", text);
  },
  triggerUniversalAlert(context, value) {
    context.commit("CREATE_UNIVERSAL_ALERT", value);
  },
  closeUniversalAlert(context) {
    context.commit("CLOSE_UNIVERSAL_ALERT");
  },
};

export default actions;
